import { Box, Button, Typography } from "@mui/material";
import React, { FC } from "react";

import { ReactComponent as OTSCompleteImage } from "../../../assets/images/OTS/ots-complete.svg";
import { useNavigate } from "react-router-dom";

const SetupComplete: FC = () => {
	const navigate = useNavigate();

	function handleFinishSetup() {
		navigate("/dashboard");
	}

	// function handleBackButtonClick() {
	// 	navigate("/cameras-list");
	// }

	return (
		<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "3rem" }}>
			<Box
				sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}
			>
				<OTSCompleteImage height={325} />

				<Typography variant="h4" color="var(--color-primary-main)" fontWeight={500}>
					Gate-Guard Setup Complete
				</Typography>
			</Box>

			<Box
				sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}
			>
				<Button disableElevation variant="contained" color="primary" onClick={handleFinishSetup}>
					Finalize Setup and Login
				</Button>

				{/* <Button color="error" onClick={handleBackButtonClick}>
					Back
				</Button> */}
			</Box>
		</Box>
	);
};

export default SetupComplete;
